/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */
import { render } from "react-dom";

import ApplicationProvider from "application/ApplicationProvider";

const rootElement = document.getElementById("application");

render(<ApplicationProvider />, rootElement);
